export class StudentFilter {
  campusId: number;
  yearLevelId: number;
  homeroomId: number;
  page: number;
  limit: number;
  name: string;
  aisId: any;
  status: string;
  active: boolean;
  exportCSV?: boolean;
  constructor() {
    this.campusId = 0;
    this.yearLevelId = 0;
    this.homeroomId = 0;
    this.page = 1;
    this.limit = 20;
    this.name = "";
    this.aisId = "";
    this.active = true;
    this.status = "active";
    this.exportCSV = false;
  }
}

export class StudentList {
  count: number;
  rows: Student[];

  constructor() {
    this.count = 0;
    this.rows = [];
  }
}

export class Student {
  id: number;
  aisId: string;
  familyName: string;
  givenName: string;
  knownName: string;
  dateOfBirth: string;
  gender: string;
  country: string;
  homeroom: Homeroom;
  active: boolean;

  constructor() {
    this.homeroom = new Homeroom();
  }
}

export class StudentImportResult {
  csv: string;
  messages: any;
  isError: boolean;
  errorType: string;
  errorMessages: any[];

  constructor() {
    this.csv = "";
    this.messages = null;
    this.isError = false;
    this.errorType = "";
    this.errorMessages = [];
  }
}

class Homeroom {
  id: number;
  name: string;
  campusId: number;
  yearLevelId: number;
}

export class StudentScheduleFilter {
  campus: number;
  year_level: number;
  page: number;
  limit: number;
  student_name: string;
  ais_id: string;
  homeroom: number;
  season_id: number;
  exportType?: string;

  constructor() {
    this.campus = 0;
    this.year_level = 0;
    this.page = 1;
    this.limit = 20;
    this.student_name = "";
    this.ais_id = "";
    this.homeroom = 0;
    this.season_id = 0;
  }
}

export class StudentScheduleList {
  total: number;
  data: Student[];

  constructor() {
    this.total = 0;
    this.data = [];
  }
}

export class AllClassScheduleList {
  total: number;
  data: AllClassSchedule[];
  count: number;
  constructor() {
    this.total = 0;
    this.data = [];
    this.count = 0;
  }
}

export class AllClassSchedule {
  id: number;
  ais_id: string;
  family_name: string;
  given_name: string;
  full_name: string;
  campus: string;
  campus_id: number;
  year_level_name: string;
  year_level_id: number;
  homeroom: string;
  homeroom_id: string;
  monday: string;
  tuesday: string;
  wednesday: string;
  thursday: string;
  friday: string;
  classes: any[];

  constructor() {}
}

export class Schedule {
  id: number;
  ais_id: string;
  family_name: string;
  given_name: string;
  full_name: string;
  tutor: string;
  campus: string;
  campus_id: number;
  year_level_name: string;
  year_level_id: number;
  monday: string;
  tuesday: string;
  wednesday: string;
  thursday: string;
  friday: string;
  parent_email: string;

  constructor() {}
}

export class StudentScheduleImportResult {
  csv: string;
  messages: any;
  isError: boolean;
  errorType: string;
  errorMessages: any[];

  constructor() {
    this.csv = "";
    this.messages = null;
    this.isError = false;
    this.errorType = "";
    this.errorMessages = [];
  }
}

// Holiday Student
export class HolidayStudentFilter {
  id: number;
  code: number;
  name: string;
  type: any;
  medical: any;
  status: any;
  page: number;
  limit: number;
  hol_class_id: number;
  export_type: string;
  constructor() {
    this.id = 0;
    this.type = 0;
    this.status = 0;
    this.medical = 0;
  }
}
export class HolidayStudentList {
  count: number;
  data: HolidayStudents[];

  constructor() {
    this.count = 0;
    this.data = [];
  }
}
export class StudentDetail {
  id: number;
  family_name: string;
  given_name: string;
  known_name: string;
  gender: string;
  date_of_birth: string;
  country: string;
  medical: HolMedical[];
  constructor() {
    this.medical = new Array<HolMedical>();
    this.known_name = "";
  }
}
export class HolidayStudents {
  id: number;
  code: string;
  family_name: string;
  given_name: string;
  known_name: string;
  gender: string;
  data_of_birth: string;
  country: string;
  medical: HolMedical[];
  status: any;
  hol_parents: HolidayParents[];
  constructor() {
    this.hol_parents = new Array<HolidayParents>();
    this.medical = new Array<HolMedical>();
  }
}
export class HolidayParentDetails {
  email: string;
  family_name: string;
  given_name: string;
  hol_parent_id: number;
  id: number;
  phone: string;
}

export class HolMedical {
  allergic: string;
  medication: string;
  under_doctor_care: string;
  limit_paticipation_athlentic: string;
  special_education_needs: string;
  special_education_support: string;
}

export class HolidayParents {
  id: number;
  email: string;
  recovery: any;
  hash: any;
  type: any;
  status: any;
  discount: boolean;
  last_booking: any;
  parent_id: number;
  hol_student_parents: HolidayStudentParents;
  hol_parent_details: HolidayParentDetails[];
  constructor() {
    this.hol_student_parents = new HolidayStudentParents();
    this.hol_parent_details = new Array<HolidayParentDetails>();
  }
}

export class HolidayStudentParents {
  hol_student_id: number;
  hol_parent_id: number;
}

export class StudentType {
  id: string;
  name: string;
}

export const STUDENT_TYPE: StudentType[] = [
  {
    id: "ais",
    name: "AIS Student",
  },
  {
    id: "other",
    name: "Non AIS Student",
  },
];

export const HOL_STUDENT_STATUS: HolStudentStatus[] = [
  {
    id: "active",
    name: "Active",
  },
  {
    id: "inactive",
    name: "Inactive",
  },
];

export class HolStudentStatus {
  id: string;
  name: string;
}

export const HOL_STUDENT_MEDICAL: HolStudentMedical[] = [
  {
    id: "allergic",
    name: "Allergic",
  },
  {
    id: "medication",
    name: "Medication",
  },
  {
    id: "under_doctor_care",
    name: "Under Doctor Care",
  },
  {
    id: "limit_paticipation_athlentic",
    name: "Limit paticipation athlentic",
  },
  {
    id: "special_education_needs",
    name: "Special Education Needs",
  },
  {
    id: "special_education_support",
    name: "Special Education Support",
  },
];

export class HolStudentMedical {
  id: string;
  name: string;
}



// WEBPACK FOOTER //
// ./src/common/modules/core/models/Student.ts